import React, { useEffect, useState, useRef } from 'react'
import cssLessonLessonText from './LessonLessonText.module.scss'
// import GoogleShareToClassRoom from '../../../Utils/GShare.js'
import {ClientGatewayInPackage, GoogleShareToClassRoom, GlobalLibs} from 'bc-react-package'

// #region Constant
const COMP_NAME = "LessonLessonText"
const INDEX_NONE = -1 // 未播放
// const PRELOAD_AUDIO_PREFIX_FOR_SENTENCE = "SentenceAudio"
// #endregion Constant

// #region Enumeration
const PlayingStatusEnum = {
    Playing: 1,
    Paused: 2,
    Stop: 3,
    Loading: 4
}

const PlayingModeEnum = {
    None: 0,
    PlayOne: 1,
    PlayAll: 2
}
// #endregion Enumeration

// #region Member Variables
let mblnInitialized = false
let mstrBookCatID = ""
let mstrLUCatSeqNo = ""
let mintAudioPlayingMode = PlayingModeEnum.None // 用來判斷是Play One或Play All
let mintAudioPlayingStatus = PlayingStatusEnum.Stop // 用來判斷現在是 播放中/暫停/停止
let mintIndexAudioPlaying = INDEX_NONE // 目前正在播放哪一個Index
let mintDictionaryToolTop = 0 // 用來 反選文字後 點擊Dictionary的的區塊位置
let mintDictionaryToolLeft = 0 // 用來 反選文字後 點擊Dictionary的的區塊位置
let msrtTextSelectionFirstLine = "" // 使用者反選範圍的文字的第一行文字
let mblnSentenceAudiosLoaded = false // 音檔是否都load完了

// #region Preload audio
// let marrSentenceAudioManifestForPreload = [] // 用於 PreloadAudio的 Sentence音檔清單的資訊
// let marrPreloadedAudio = [] // 用於 PreloadAudio的 已經Preload好的音檔 放在此Array中
// let mstrCurrentSoundName = "" // 用於 PreloadAudio的 離開LU的時候 停止播放音檔
// #endregion Preload audio

// #endregion Member Variables

function LessonLessonText(props)
{
    console.log(COMP_NAME + ".Begin:", props)
    console.log(COMP_NAME + ".props.LUInfo: ", props.LUInfo)
    console.log(COMP_NAME + ".props.LessonID: ", props.LessonID)

    // #region Init State
    const [showPinyinText, setShowPinyinText] = useState(false)
    const [showEnglishText, setShowEnglishText] = useState(true)
    const [showDitionaryTool, setShowDitionaryTool] = useState(false)
    const [, setUpdateDataTime] = useState(0)
    // #endregion Init State

    // #region Init Ref
    let mrefScrollArea = useRef(null)
    // #endregion Init Ref

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    let mrefCleanUp = useRef(null)

    mrefPaintedMe.current = PaintedMe
    mrefCleanUp.current = CleanUp
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)
        mblnInitialized = true
        mstrBookCatID = window.gSession.App.BookCatID.toString().PadLeft(2)
        mstrLUCatSeqNo = props.LUInfo.LUCatSeqNo
    }
    // #endregion First Launch

    // #region useEffect
    
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")
        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            mrefCleanUp.current()
        }
    }, [props.PathName])
    // #endregion useEffect

    // #region Painted Me
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe: ")

        window.AudioLibs.RegisterEventHandlerRef(PlayAudioEndHandler, window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
        window.AudioLibs.RegisterEventHandlerRef(PlayAudioCanPlayHandler, window.AudioLibs.RegisterEventTypeEnum.AudioCanPlay)

        document.addEventListener('touchstart', DocumentPointerDownHandler)
        document.addEventListener('mousedown', DocumentPointerDownHandler)
        RegisterLanguageChangeHandler()
        RegisterGlossaryCallback()
    }

    function CleanUp()
    {
        console.log(COMP_NAME + ".CleanUp: ")

        mblnInitialized = false
        mintAudioPlayingMode = PlayingModeEnum.None
        mintAudioPlayingStatus = PlayingStatusEnum.Stop
        mintIndexAudioPlaying = INDEX_NONE
        mblnSentenceAudiosLoaded = false
        window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
        window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioCanPlay)
        
        document.removeEventListener('touchstart', DocumentPointerDownHandler)
        document.removeEventListener('mousedown', DocumentPointerDownHandler)
        UnregisterLanguageChangeHandler()
        UnregisterGlossaryCallback()

        // if (mstrCurrentSoundName !== "")
        // {
        //     AudioContextStopSound(mstrCurrentSoundName)
        //     mstrCurrentSoundName = ""
        // }
        window.AudioLibs.StopAudio()

        // marrSentenceAudioManifestForPreload = []
        // marrPreloadedAudio = []
    }
    // #endregion Painted Me

    // #region OnTapHandler

    function DisplayPinyinTextOnTapHandler(IsShow)
    {
        console.log(COMP_NAME + ".DisplayPinyinTextOnTapHandler")

        StopAudioAndResetPlayingIndex()

        setShowPinyinText(IsShow)
    }

    function DisplayEnglishTextOnTapHandler(IsShow)
    {
        console.log(COMP_NAME + ".DisplayEnglishTextOnTapHandler")

        StopAudioAndResetPlayingIndex()
        
        setShowEnglishText(IsShow)
    }

    // 播放某一個音檔
    function StartPlayOne(Index)
    {
        // 從頭開始播放某一特定音檔
        console.log(COMP_NAME + ".StartPlayOne: ", Index)
        let strAudioFN = props.LUInfo.Sentence[Index].AudioFN
        console.log("strAudioFN: ", strAudioFN)
        let strAudioUrl = window.Globals.GetResourceUrl(mstrBookCatID, props.LessonID, window.gResourceTypeEnum.Audio, strAudioFN)
        console.log("strAudioUrl: ", strAudioUrl)
        window.AudioLibs.PlayAudio(strAudioUrl)
    }

    // 從第一個音檔開始逐一播放所有音檔
    function StartPlayAll()
    {
        console.log(COMP_NAME + ".StartPlayAll")

        // 從頭開始播放Play All
        mintIndexAudioPlaying = 0 // 從第一句開始播

        
        mintAudioPlayingStatus = PlayingStatusEnum.Playing
        ScrollToSentence(mintIndexAudioPlaying)
        // PlayPreloadedSentenceAudio(mintIndexAudioPlaying) // Play peloaded audio
        StartPlayOne(mintIndexAudioPlaying)
    }

    function PlayAllOrPauseAllAudioOnTapHandler()
    {
        console.log(COMP_NAME + ".PlayAllOrPauseAllAudioOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        console.log("mintAudioPlayingMode:", mintAudioPlayingMode)
        console.log("mintIndexAudioPlaying:", mintIndexAudioPlaying)
        console.log("mintAudioPlayingStatus:", mintAudioPlayingStatus)
        
        if(mintAudioPlayingMode === PlayingModeEnum.PlayOne)
        {
            // 如果目前是Play One 就停止目前的Play One
            mintAudioPlayingMode = PlayingModeEnum.None
            mintAudioPlayingStatus = PlayingStatusEnum.Stop
            mintIndexAudioPlaying = INDEX_NONE
            window.AudioLibs.StopAudio()
        }

        if (mintAudioPlayingStatus === PlayingStatusEnum.Stop)
        {
            mintAudioPlayingMode = PlayingModeEnum.PlayAll
            // 目前為停止播放

            console.log("Stop => Play")

            if(!mblnSentenceAudiosLoaded)
            {
                // 音檔未全部Load過
                // OpenLoadingMask(window.gAppUI.MSG_LoadMask_LoadingAudios)
                // PreloadSentenceAudiosProcessBegin() // 先把所有的音檔Preload完後 再播放
                StartPlayAll()
                setUpdateDataTime(new Date().getTime())
            }
            else
            {
                // 音檔已經全部Load過
                StartPlayAll()
                setUpdateDataTime(new Date().getTime())
            }
        }
        else if (mintAudioPlayingStatus === PlayingStatusEnum.Paused)
        {
            // 目前為暫停播放中
            if (mintAudioPlayingMode === PlayingModeEnum.PlayAll)
            {
                console.log("Pause => Continue Playing all")
                // 若之前是在播放Play All的時候按暫停 點擊Play All 則繼續播放
                
                mintAudioPlayingStatus = PlayingStatusEnum.Playing
                window.AudioLibs.Play()
            }
            else if (mintAudioPlayingMode === PlayingModeEnum.PlayOne)
            {
                // 若之前是在播放Play One的時候按暫停時 點擊Play All 則從第一句開始播放
                console.log("Pause => Play all audio")
                mintAudioPlayingMode = PlayingModeEnum.PlayAll
                mintIndexAudioPlaying = 0 // 從第一句開始播
                
                mintAudioPlayingStatus = PlayingStatusEnum.Playing
                // PlayPreloadedSentenceAudio(mintIndexAudioPlaying)
                StartPlayOne(mintIndexAudioPlaying)
            }
        }
        else if (mintAudioPlayingStatus === PlayingStatusEnum.Playing)
        {
            // 目前為正在播放中
            if (mintAudioPlayingMode === PlayingModeEnum.PlayAll)
            {
                // 點擊時 正處於Playing all的Audio 則執行Pause
                mintAudioPlayingStatus = PlayingStatusEnum.Paused
                window.AudioLibs.PauseAudio()
            }
            else if (mintAudioPlayingMode === PlayingModeEnum.PlayOne)
            {
                // 點擊時 正處於Playing one的Audio 則從頭播放
                console.log("Play => Play all audio")
                mintAudioPlayingMode = PlayingModeEnum.PlayAll
                mintIndexAudioPlaying = 0 // 從第一句開始播
                
                mintAudioPlayingStatus = PlayingStatusEnum.Playing
                ScrollToSentence(mintIndexAudioPlaying)
                // PlayPreloadedSentenceAudio(mintIndexAudioPlaying)
                StartPlayOne(mintIndexAudioPlaying)
            }
        }
        setUpdateDataTime(new Date().getTime())
    }

    function StopAllAudioOnTapHandler()
    {
        console.log(COMP_NAME + ".StopAllAudioOnTapHandler")

        StopAudioAndResetPlayingIndex()
        setUpdateDataTime(new Date().getTime())
    }

    function PlayOneOrPauseOneAudioOnTapHandler(Index)
    {
        console.log(COMP_NAME + ".PlayOneOrPauseOneAudioOnTapHandler")

        // 按下後 延遲一下再切換 解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        console.log("Index:", Index)
        console.log("mintAudioPlayingMode:", mintAudioPlayingMode)
        console.log("mintIndexAudioPlaying:", mintIndexAudioPlaying)
        console.log("mintAudioPlayingStatus:", mintAudioPlayingStatus)

        if (mintAudioPlayingStatus === PlayingStatusEnum.Stop)
        {
            // 目前為停止播放
            console.log("Stop => Play")
            mintIndexAudioPlaying = Index
            mintAudioPlayingStatus = PlayingStatusEnum.Loading //  顯示Loading Icon

            mintAudioPlayingMode = PlayingModeEnum.PlayOne
            StartPlayOne(mintIndexAudioPlaying)
        }
        else if (mintAudioPlayingStatus === PlayingStatusEnum.Paused)
        {
            if (mintAudioPlayingMode === PlayingModeEnum.PlayOne)
            {
                // 目前為暫停播放中
                if (mintIndexAudioPlaying === Index)
                {
                    console.log("Play One Pause => Continue Playing")
                    // 點擊的是 正處於Paused的Audio 則 繼續播放
                    
                    mintAudioPlayingStatus = PlayingStatusEnum.Playing
                    window.AudioLibs.Play()
                }
                else
                {
                    console.log("Play One Pause => Play another audio")
                    // 點擊的是 非處於Paused的Audio 則 播放音檔
                    mintIndexAudioPlaying = Index
                    
                    mintAudioPlayingStatus = PlayingStatusEnum.Playing
                    StartPlayOne(mintIndexAudioPlaying)
                }
            }
            else if (mintAudioPlayingMode === PlayingModeEnum.PlayAll)
            {
                console.log("Play All Pause => Play One")
                // 若之前是在播放Play All的時候按暫停 則 直接從頭播放音檔
                mintIndexAudioPlaying = Index
                
                mintAudioPlayingStatus = PlayingStatusEnum.Playing
                mintAudioPlayingMode = PlayingModeEnum.PlayOne
                ScrollToSentence(mintIndexAudioPlaying)
                StartPlayOne(mintIndexAudioPlaying)
            }
        }
        else if (
            (mintAudioPlayingStatus === PlayingStatusEnum.Playing) ||
            (mintAudioPlayingStatus === PlayingStatusEnum.Loading)
            )
        {
            if (mintAudioPlayingMode === PlayingModeEnum.PlayOne)
            {
                // 目前為正在播放Play One的音檔
                if (mintIndexAudioPlaying === Index)
                {
                    console.log("Play One Playing => Pause current audio")
                    // 點擊的是 正處於Playing的Audio 則 執行Paused
                    mintAudioPlayingStatus = PlayingStatusEnum.Paused
                    window.AudioLibs.PauseAudio()
                }
                else
                {
                    console.log("Play One Playing => Play another audio")
                    // 點擊的是 非處於Playing的Audio 則 執行Playing
                    mintIndexAudioPlaying = Index
                    mintAudioPlayingStatus = PlayingStatusEnum.Loading //  顯示Loading Icon
                    StartPlayOne(mintIndexAudioPlaying)
                }
            }
            else if (mintAudioPlayingMode === PlayingModeEnum.PlayAll)
            {
                console.log("Play All Playing => Play One audio")

                // 目前為正在播放Play All的音檔 則 執行播放
                mintIndexAudioPlaying = Index
                
                mintAudioPlayingStatus = PlayingStatusEnum.Playing
                mintAudioPlayingMode = PlayingModeEnum.PlayOne
                ScrollToSentence(mintIndexAudioPlaying)
                StartPlayOne(mintIndexAudioPlaying)
            }
        }
        setUpdateDataTime(new Date().getTime())
    }

    function StopOneAudioOnTapHandler()
    {
        console.log(COMP_NAME + ".StopOneAudioOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        mintAudioPlayingMode = PlayingModeEnum.None
        mintAudioPlayingStatus = PlayingStatusEnum.Stop
        mintIndexAudioPlaying = INDEX_NONE
        window.AudioLibs.StopAudio()

        setUpdateDataTime(new Date().getTime())
    }

    // #endregion OnTapHandler

    // #region Other Handler
    function LanguageOnChangeHandler()
    {
        console.log(COMP_NAME + ".LanguageOnChangeHandler: ")
    }

    // 手指或滑鼠按下去 反選文字 開始反選時"按下去"的事件onPointerDown 
    function TextAreaPointDownHandler(e, SentenceIndex)
    {
        console.log(COMP_NAME + ".TextAreaPointDownHandler: ", e, SentenceIndex)
        console.log("e.target: ", e.target)
        console.log("e.target.classList: ", e.target.classList)

        // 依目前點擊哪一個Sentence 用來設定Dictionary Tool要顯示的高度
        let arrMenuLessonElements = mrefScrollArea.current.querySelectorAll("[name='nameScrollSentence']")
        console.log("arrMenuLessonElements: ", arrMenuLessonElements)
        if (arrMenuLessonElements.length > 0)
        {
            let intOffsetTop = arrMenuLessonElements[SentenceIndex].offsetTop
            console.log("ScrollToSentence: intOffsetTop:", intOffsetTop)
            mintDictionaryToolTop = intOffsetTop - 20 // Ditionary Tool顯示在反選的字上面 20px
        }

        // 註冊 手指或滑鼠按下去 反選文字 按"下去"的事件onPointerUp / touchend / mouseup
        // onPointerUp 在iOS 12.x無法使用, touchend用於App, mouseup用於Web
        // pointerup事件 註冊在整個DOM 因為使用者選取的時候 可能會跨到其他的div才放開手指或滑鼠 所以pointerup的事件 要註冊在整個DOM才能收觸發
        document.addEventListener("touchend", DocumentPointerUpHandler) // App
        document.addEventListener("mouseup", DocumentPointerUpHandler) // Web
    }

    // 整個DOM 註冊DocumentPointerDownHandler的事件 用於反選字後 再點擊其他地方 讓Ditionary Tool消失
    function DocumentPointerDownHandler(e)
    {
        console.log(COMP_NAME + ".DocumentPointerDownHandler: ", e)
        setShowDitionaryTool(false)
    }

    // 手指或滑鼠按下去 反選文字 開始反選時按下去 移動後選多字後"放開"的事件onPointerUp / touchend / mouseup
    function DocumentPointerUpHandler(e)
    {
        console.log(COMP_NAME + ".DocumentPointerUpHandler: ", e)

        let objTextSelection = document.getSelection();
        console.log("objTextSelection: ", objTextSelection)

        if (objTextSelection !== null)
        {
            let arrAllTextSelection = objTextSelection.toString().split(/\r?\n/); // richard: selction 有可能跨多行 // 使用者反選範圍的文字 每一行分別放在Array的Element
            console.log("arrAllTextSelection:", arrAllTextSelection)
            msrtTextSelectionFirstLine = arrAllTextSelection[0].trim() // 使用者選取的範圍 可能跨多個div 只留第一行的字
            console.log("msrtTextSelectionFirstLine: ", msrtTextSelectionFirstLine)
            // console.log("arrAllTextSelection: ", arrAllTextSelection)
            // console.log("objTextSelection.toString(): ", objTextSelection.toString())

            if (msrtTextSelectionFirstLine !== "")
            {
                let objSlectionRect = objTextSelection.getRangeAt(0).getBoundingClientRect()
                // console.log("objSlectionRect.top: ", objSlectionRect.top) // 不用 objSlectionRect.top 因為Scroll後 就不正確 除非是以最外層DOM定位 則Scroll時 不會跟著動
                console.log("objSlectionRect.left: ", objSlectionRect.left)

                // 注意 字反選 divCellDialogSentenceMajorOrMinorText 單行或多行時 objSlectionRect.left 是不同的
                // 字反選 divCellDialogSentenceMajorOrMinorText 裡面的單行字時 objSlectionRect.left 就是目前反選的左側 objSlectionRect.left 是 218
                // 字反選 divCellDialogSentenceMajorOrMinorText 其實是有選到第二行的左側的 divCellDialogNameArea 只是瀏覽器上 並沒有看到divCellDialogNameArea內的字被反選 所以多行時 objSlectionRect.left 是 80 (即 80 = 218 - 120 - 12 說明: 單行反選的objSlectionRect.left:218px - divCellDialogNameArea width:120px + divCellDialogSentenceArea margin-left: 12px)
                let intobjSlectionRectLeft = 0
                if (arrAllTextSelection.length === 1)
                {
                    // 反選單行
                    intobjSlectionRectLeft = objSlectionRect.left
                }
                else if (arrAllTextSelection.length > 1)
                {
                    // 反選多行
                    intobjSlectionRectLeft = objSlectionRect.left + 120 + 12 // divCellDialogNameArea width:120px + divCellDialogSentenceArea margin-left: 12px
                }
                console.log("intobjSlectionRectLeft: ", intobjSlectionRectLeft)

                // console.log("msrtTextSelectionFirstLine.length: ", msrtTextSelectionFirstLine.length)
                mintDictionaryToolLeft = intobjSlectionRectLeft - 30 - 50 - (76 / 2) + ((msrtTextSelectionFirstLine.length * 20) / 2) // divContentArea left: 30px - divScrollArea left: 50px - divModifyCharacterPopupArea width: 76px / 2,  (msrtTextSelectionFirstLine.length第一行幾個字 * 每個中文字的大略抓寬度 20px, / 2 第一行字的左右的中間位置 )
                setShowDitionaryTool(true)
            }
        }
        document.removeEventListener("touchend", DocumentPointerUpHandler) // App 移除註冊整個DOM的pointerup事件
        document.removeEventListener("mouseup", DocumentPointerUpHandler) // Web 移除註冊整個DOM的pointerup事件
    }

    // 反選文字後的 點擊Ditionary Tool
    function DitionaryPointDownHandler(event)
    {
        console.log(COMP_NAME + ".DitionaryPointDownHandler: ", event)
        console.log("msrtTextSelectionFirstLine: ", msrtTextSelectionFirstLine)
        document.getSelection().removeAllRanges()
        event.stopPropagation()
        
        StopAudioAndResetPlayingIndex()

        OpenGlossaryWithSearchText(msrtTextSelectionFirstLine)
    }

    // #endregion Other Handler

    // #region Other Functions

    function StopAudioAndResetPlayingIndex()
    {
        console.log(COMP_NAME + ".StopAudioAndResetPlayingIndex")

        // if (mstrCurrentSoundName !== "")
        // {
        //     AudioContextStopSound(mstrCurrentSoundName)
        // }
        window.AudioLibs.StopAudio()

        mintAudioPlayingMode = PlayingModeEnum.None
        mintAudioPlayingStatus = PlayingStatusEnum.Stop
        mintIndexAudioPlaying = INDEX_NONE
    }

    // #region Preload Audio

    /*
    2022-08-19 直接播放讀取速度還可以接受 改用直接播放 不先Preload避免一開始的等待

    // 已讀取完Sentence Audio後的處理
    function SentenceAudiosLoadedHandler(SoundObject, ManifestIndexLoaded)
    {
        console.log(COMP_NAME + ".SentenceAudiosLoadedHandler: ", SoundObject, ManifestIndexLoaded)

        if (ManifestIndexLoaded < (marrSentenceAudioManifestForPreload.length - 1))
        {
            // 讀下一個Sentence Audio
            PreloadSentenceAudio(ManifestIndexLoaded + 1)
        }
        else if(!mblnSentenceAudiosLoaded)
        {
            // 已讀完所有Sentence Audio
            PreloadSentenceAudiosProcessEnd()
            mblnSentenceAudiosLoaded = true
        }
    }
    
    // Start preloading sentence audio
    function PreloadSentenceAudiosProcessBegin()
    {
        console.log(COMP_NAME + ".PreloadSentenceAudiosProcessBegin: ")

        marrSentenceAudioManifestForPreload = GetSentenceAudiosManifest()
        console.log("marrSentenceAudioManifestForPreload: ", marrSentenceAudioManifestForPreload)
        PreloadSentenceAudio(0) // 從第一個 ManifestIndex:0 開始作Preload Audio
    }

    function PreloadSentenceAudiosProcessEnd()
    {
        console.log(COMP_NAME + ".PreloadSentenceAudiosProcessEnd")   

        CloseLoadingMask()

        // Play All
        StartPlayAll()
        setUpdateDataTime(new Date().getTime())
    }

    // Preload sentence audio
    function PreloadSentenceAudio(ManifestIndex)
    {
        console.log(COMP_NAME + ".PreloadSentenceAudio: ", ManifestIndex)

        AudioContextLoadAudio(marrSentenceAudioManifestForPreload[ManifestIndex], ManifestIndex)
    }

    // Get sentence audio info for preload audio    
    function GetSentenceAudiosManifest()
    {
        console.log(COMP_NAME + ".GetSentenceAudiosManifest")

        console.log("props.LUInfo.Sentence[0].AudioFN: ", props.LUInfo.Sentence[0].AudioFN)

        let arrManifest = []
        let intIndex = 0
        let intCount = props.LUInfo.Sentence.length
        let strAudioUrl = ""

        for (intIndex = 0; intIndex < intCount; intIndex++)
        {
            let strAudioFN = props.LUInfo.Sentence[intIndex].AudioFN
            console.log("strAudioFN: ", strAudioFN)
            strAudioUrl = window.Globals.GetResourceUrl(mstrBookCatID, props.LessonID, window.gResourceTypeEnum.Audio, strAudioFN)
            console.log("strAudioUrl: ", strAudioUrl)

            arrManifest.push({
                Name: PRELOAD_AUDIO_PREFIX_FOR_SENTENCE + intIndex.toString(),
                Src: strAudioUrl,
                Callback: SentenceAudiosLoadedHandler
            })
        }
        console.log("arrManifest: ", arrManifest)
        return arrManifest
    }

    // Load Audio
    function AudioContextLoadAudio(SoundObject, ManifestIndex)
    {
        console.log(COMP_NAME + ".AudioContextLoadAudio: ", SoundObject, ManifestIndex)

        let objCallback = {
            "SoundObject": SoundObject,
            "ManifestIndex": ManifestIndex
        }
        marrPreloadedAudio[SoundObject.Name] = SoundObject // Call by reference
        window.AudioLibs.PreloadAudio(SoundObject.Src, objCallback)
    }

    // Stop playing preloaded audio
    function AudioContextStopSound(SoundName)
    {
        console.log(COMP_NAME + ".AudioContextStopSound: ", SoundName)

        console.log("marrPreloadedAudio: ", marrPreloadedAudio)
        console.log("marrPreloadedAudio[SoundName]: ", marrPreloadedAudio[SoundName])
        if (marrPreloadedAudio[SoundName])
        {
            // Stop audio
            mstrCurrentSoundName = ""
            window.AudioLibs.StopAudio()
        }
    }

    // Playing preloaded audio
    function AudioContextPlaySound(SoundName)
    {
        console.log(COMP_NAME + ".AudioContextPlaySound: ", SoundName)

        console.log("marrPreloadedAudio: ", marrPreloadedAudio)
        console.log("marrPreloadedAudio[SoundName]: ", marrPreloadedAudio[SoundName])
        if (marrPreloadedAudio[SoundName])
        {
            mstrCurrentSoundName = SoundName
            window.AudioLibs.PlayAudio(marrPreloadedAudio[SoundName].Src)
        }
    }

    // Play preloaded audio by index
    function PlayPreloadedSentenceAudio(IndexSentenceAudio)
    {
        console.log(COMP_NAME + ".PlayPreloadedSentenceAudio: ", IndexSentenceAudio)
        AudioContextPlaySound(PRELOAD_AUDIO_PREFIX_FOR_SENTENCE + IndexSentenceAudio.toString())
    }

    */

    // #endregion Preload Audio

    function RegisterGlossaryCallback()
    {
        console.log(COMP_NAME + ".RegisterGlossaryCallback: ")
        // 因為ToolBarTopUnit點擊Glossary開啟後 會搶走AudioEnded, AudioCanPlay事件 所以如果LU有使用Audio Event 就必須在Glossary關閉時 需呼叫mobjCallerInfoForGlossaryWindow.CallbackRef 觸發 讓Audio Event再次註冊到LU
        let objCallbackData = {
            "Action": "RegisterGlossaryCallback",
            "CallbackRef": GlossaryWindowCallback
        }
        props.CallbackRef(objCallbackData)
    }

    function UnregisterGlossaryCallback()
    {
        console.log(COMP_NAME + ".UnregisterGlossaryCallback: ")
        let objCallbackData = {
            "Action": "UnregisterGlossaryCallback"
        }
        props.CallbackRef(objCallbackData)
    } 

    function RegisterLanguageChangeHandler()
    {
        console.log(COMP_NAME + ".RegisterLanguageChangeHandler: ")
        let objCallbackData = {
            "Action": "RegisterLanguageChangeHandler",
            "Function": LanguageOnChangeHandler
        }
        props.CallbackRef(objCallbackData)
    }

    function UnregisterLanguageChangeHandler()
    {
        console.log(COMP_NAME + ".UnregisterLanguageChangeHandler: ")
        let objCallbackData = {
            "Action": "UnregisterLanguageChangeHandler"
        }
        props.CallbackRef(objCallbackData)
    }
    // #endregion Other Functions

    // #region LoadingMask and Alert
    // function OpenLoadingMask(LoadingMsg)
    // {
    //     console.log("OpenLoadingMask: ", LoadingMsg)

    //     let objCallbackData = {
    //         "Action": "OpenLoadingMask",
    //         "Message": LoadingMsg
    //     }
    //     props.CallbackRef(objCallbackData)
    // }

    // function CloseLoadingMask()
    // {
    //     console.log(COMP_NAME + ".CloseLoadingMask")

    //     let objCallbackData = {
    //         "Action": "CloseLoadingMask"
    //     }
    //     props.CallbackRef(objCallbackData)
    // }
    // #endregion LoadingMask and Alert

    // #region Toast
    // #endregion Toast

    function RegisterAudioEvent()
    {
        console.log(COMP_NAME + ".RegisterAudioEvent")

        window.AudioLibs.RegisterEventHandlerRef(PlayAudioCanPlayHandler, window.AudioLibs.RegisterEventTypeEnum.AudioCanPlay)
        window.AudioLibs.RegisterEventHandlerRef(PlayAudioEndHandler, window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
    }

    // #region Component Callback
    function GlossaryWindowCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".GlossaryWindowCallback.CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "CloseShowGlossary")
        {
            console.log("GlossaryWindowCallback.CloseShowGlossary")
            RegisterAudioEvent() // 因為開啟GlossaryWindow時 Audio Event被註冊過去 所以關閉GlossaryWindow時 要再註冊回此
        }
    }
    // #endregion Component Callback

    // #region Other Functions

    /*===========================================
    summary: 點選 GoogleClassroom 元件
    remarks: 000 Jeff 20XX/XX/XX Create
             001 Tim 2023/06/15 CallApp前 清空 AppCallbackRef
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function Share2GoogleClassroom4AppOnTapHandler()
    {
        console.log(COMP_NAME + ".Share2GoogleClassroom4AppOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let strUrl = window.Globals.GenerateShare2GoogleClassroomUrl(props.LUInfo.LUCatSeqNo)
        console.log("Share2GoogleClassroom4AppOnTapHandler strUrl: ", encodeURIComponent(strUrl))

        // In App
        let intAction = window.gConst.ACTION_OEPN_APP_SHARE_WITH_URL;
        let intPositionX = 54 // 視窗的小箭頭位置
        let intPositionY = 112 // 視窗的小箭頭位置

        let strQueryString = "Action=" + intAction
        strQueryString += "&Credential=" + window.gSession.Acc.Credential
        strQueryString += "&BackRoute="
        strQueryString += "&Url=" + encodeURIComponent(strUrl)
        strQueryString += "&PosX=" + intPositionX.toString()
        strQueryString += "&PosY=" + intPositionY.toString()

        console.log("Share2GoogleClassroom4AppOnTapHandler strQueryString: ", strQueryString)

        // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
        ClientGatewayInPackage.CallApp(strQueryString)
    } // end of Share2GoogleClassroom4AppOnTapHandler

    function PlayAudioCanPlayHandler()
    {
        console.log(COMP_NAME + ".PlayAudioCanPlayHandler: ")

        if(mintAudioPlayingStatus === PlayingStatusEnum.Loading)
        {
            
            mintAudioPlayingStatus = PlayingStatusEnum.Playing
            setUpdateDataTime(new Date().getTime())
        }
    }

    function PlayAudioEndHandler()
    {
        console.log(COMP_NAME + ".PlayAudioEndHandler: ")

        // mstrCurrentSoundName = ""
        
        if (mintAudioPlayingMode === PlayingModeEnum.PlayOne)
        {
            mintIndexAudioPlaying = INDEX_NONE
            mintAudioPlayingStatus = PlayingStatusEnum.Stop
            mintAudioPlayingMode = PlayingModeEnum.None
        }
        else if (mintAudioPlayingMode === PlayingModeEnum.PlayAll)
        {
            console.log("mintIndexAudioPlaying: ", mintIndexAudioPlaying)
            if (mintIndexAudioPlaying < (props.LUInfo.Sentence.length - 1))
            {
                
                mintAudioPlayingStatus = PlayingStatusEnum.Playing
                mintIndexAudioPlaying++
                ScrollToSentence(mintIndexAudioPlaying)
                // PlayPreloadedSentenceAudio(mintIndexAudioPlaying)
                StartPlayOne(mintIndexAudioPlaying)
            }
            else if (mintIndexAudioPlaying === (props.LUInfo.Sentence.length - 1))
            {
                console.log("PlayAll last audio paly end")
                // 播完最後一的音檔
                mintIndexAudioPlaying = INDEX_NONE
                mintAudioPlayingStatus = PlayingStatusEnum.Stop
                mintAudioPlayingMode = PlayingModeEnum.None
            }
        }
        setUpdateDataTime(new Date().getTime())
    }

    function OpenGlossaryWithSearchText(Text)
    {
        console.log(COMP_NAME + ".OpenGlossaryWithSearchText: ", Text)

        // Stop Audio
        StopAudioAndResetPlayingIndex()
        setUpdateDataTime(new Date().getTime())

        let objCallbackData = {
            "Action": "OpenGlossaryWithSearchText",
            "SearchText": Text
        }
        props.CallbackRef(objCallbackData)
    }

    function ScrollToSentence(SentenceIndex)
    {
        console.log(COMP_NAME + ".ScrollToSentence.SentenceIndex: ", SentenceIndex)

        if (mrefScrollArea.current !== null)
        {
            // let intScrollHeight = mrefScrollArea.current.scrollHeight; // scrollHeight Ref: https://www.w3schools.com/jsref/prop_element_scrollheight.asp
            // let intScrollWidth = mrefScrollArea.current.scrollWidth; // scrollWidth
            // let intScrollLeft = mrefScrollArea.current.scrollLeft; // scrollLeft
            // let intScrollTop = mrefScrollArea.current.scrollTop; // scrollTop

            // console.log("intScrollHeight:", intScrollHeight)
            // console.log("intScrollWidth:", intScrollWidth)
            // console.log("intScrollLeft:", intScrollLeft)
            // console.log("intScrollTop:", intScrollTop)

            // let intClientHeight = mrefScrollArea.current.clientHeight; // .divScrollArea 的高度 // clientHeight Ref: https://www.w3schools.com/jsref/prop_element_clientheight.asp
            // let intClientWidth = mrefScrollArea.current.clientWidth; // clientWidth Ref: 
            // let intClientTop = mrefScrollArea.current.clientTop; // clientTop
            // let intClientLeft = mrefScrollArea.current.clientLeft; // clientLeft

            // console.log("intClientHeight:", intClientHeight)
            // console.log("intClientWidth:", intClientWidth)
            // console.log("intClientTop:", intClientTop)
            // console.log("intClientLeft:", intClientLeft)

            // let intScrollTop = mrefScrollArea.current.scrollTop;
            // let intClientHeight = mrefScrollArea.current.clientHeight;
            // let intScrollHeight = mrefScrollArea.current.scrollHeight;

            let arrMenuLessonElements = mrefScrollArea.current.querySelectorAll("[name='nameScrollSentence']")
            console.log("arrMenuLessonElements: ", arrMenuLessonElements)
            if (arrMenuLessonElements.length > 0)
            {
                let intOffsetTop = arrMenuLessonElements[SentenceIndex].offsetTop
                console.log("ScrollToSentence: intOffsetTop:", intOffsetTop)
                GlobalLibs.ExecuteScrollTo(mrefScrollArea.current, intOffsetTop, 0, 300)
            }
        }
        else
        {
            console.log("mrefScrollArea不存在 不應該出現")
        }
    }
    // #endregion Other Functions

    // #region Get ClassName and Style
    function GetClsPlayAllOrPauseAllButton()
    {
        // console.log(COMP_NAME + ".GetClsPlayAllOrPauseAllButton")

        let objCls = cssLessonLessonText.divHeaderRightPlayAllButtonPlayButton

        if (
            (mintAudioPlayingMode === PlayingModeEnum.PlayAll) &&
            (mintAudioPlayingStatus === PlayingStatusEnum.Playing)
            )
        {
            objCls = cssLessonLessonText.divHeaderRightPlayAllButtonPauseButton
        }

        return objCls
    }

    function GetClsStopAllButton()
    {
        // console.log(COMP_NAME + ".GetClsStopAllButton")

        let objCls = cssLessonLessonText.divHeaderButtonStopAllButtonDisable

        if (
            (mintAudioPlayingMode === PlayingModeEnum.PlayAll) &&
            (
                (mintAudioPlayingStatus === PlayingStatusEnum.Playing) ||
                (mintAudioPlayingStatus === PlayingStatusEnum.Paused)
                )
        )
        {
            objCls = cssLessonLessonText.divHeaderButtonStopAllButton
        }

        return objCls
    }

    function GetClsPlayOrPausButton(Index)
    {
        // console.log(COMP_NAME + ".GetClsPlayOrPausButton")

        // console.log("mintAudioPlayingMode: ", mintAudioPlayingMode)
        // console.log("mintAudioPlayingStatus: ", mintAudioPlayingStatus)
        // console.log("mintIndexAudioPlaying: ", mintIndexAudioPlaying)
        // console.log("Index: ", Index)

        let objCls = cssLessonLessonText.divRowPlayButton

        if (
            (mintAudioPlayingMode === PlayingModeEnum.PlayOne) &&
            (mintAudioPlayingStatus === PlayingStatusEnum.Loading) &&
            (mintIndexAudioPlaying === Index)
        )
        {
            // 讀取音檔中
            objCls = cssLessonLessonText.divRowLoadingButton
        }
        else if (
            (mintAudioPlayingMode === PlayingModeEnum.PlayOne) &&
            (mintAudioPlayingStatus === PlayingStatusEnum.Playing) &&
            (mintIndexAudioPlaying === Index)
            )
        {
            // Play One 正在播放此
            objCls = cssLessonLessonText.divRowPauseButton
        }
        else if (
            (mintAudioPlayingMode === PlayingModeEnum.PlayAll) &&
            (mintAudioPlayingStatus === PlayingStatusEnum.Playing) &&
            (mintIndexAudioPlaying === Index)
            )
        {
            // Play All 正在播放此
            objCls = cssLessonLessonText.divRowPlayButtonDisable
        }

        return objCls
    }

    function GetClsStopButton(Index)
    {
        // console.log(COMP_NAME + ".GetClsStopButton")
        // console.log("Index", Index)
        // console.log("mintIndexAudioPlaying", mintIndexAudioPlaying)

        let objCls = cssLessonLessonText.divRowStopButtonDisable

        if (
            (mintAudioPlayingMode === PlayingModeEnum.PlayOne) &&
            (mintIndexAudioPlaying === Index) &&
            ((mintAudioPlayingStatus === PlayingStatusEnum.Playing) || (mintAudioPlayingStatus === PlayingStatusEnum.Paused))
            )
        {
            objCls = cssLessonLessonText.divRowStopButton
        }

        return objCls
    }

    function GetClsPinyinOn()
    {
        // console.log(COMP_NAME + ".GetClsPinyinOn")

        let objCls = cssLessonLessonText.divHeaderRightPinyinButtonOnDisable

        if (showPinyinText)
        {
            objCls = cssLessonLessonText.divHeaderRightPinyinButtonOnEnable
        }

        return objCls
    }

    function GetClsPinyinOff()
    {
        // console.log(COMP_NAME + ".GetClsPinyinOff")

        let objCls = cssLessonLessonText.divHeaderRightPinyinButtonOffDisable

        if (!showPinyinText)
        {
            objCls = cssLessonLessonText.divHeaderRightPinyinButtonOffEnable
        }

        return objCls
    }

    function GetClsEnglishOn()
    {
        // console.log(COMP_NAME + ".GetClsEnglishOn")

        let objCls = cssLessonLessonText.divHeaderRightEnglishButtonOnDisable

        if (showEnglishText)
        {
            objCls = cssLessonLessonText.divHeaderRightEnglishButtonOnEnable
        }

        return objCls
    }

    function GetClsEnglishOff()
    {
        // console.log(COMP_NAME + ".GetClsEnglishOff")

        let objCls = cssLessonLessonText.divHeaderRightEnglishButtonOffDisable

        if (!showEnglishText)
        {
            objCls = cssLessonLessonText.divHeaderRightEnglishButtonOffEnable
        }

        return objCls
    }

    function GetClsCellDialogSentencePinyinText()
    {
        // console.log(COMP_NAME + ".GetClsCellDialogSentencePinyinText")

        let objCls = cssLessonLessonText.divHidden
        if (showPinyinText)
        {
            objCls = cssLessonLessonText.divCellDialogSentencePinyinText
        }
        return objCls
    }

    function GetClsCellDialogSentenceEnglishText()
    {
        // console.log(COMP_NAME + ".GetClsCellDialogSentenceEnglishText")

        let objCls = cssLessonLessonText.divHidden
        if (showEnglishText)
        {
            objCls = cssLessonLessonText.divCellDialogSentenceEnglishText
        }
        return objCls
    }

    function GetClsDictionaryTool(StateShowDictionaryTool)
    {
        // console.log(COMP_NAME + ".GetClsDictionaryTool: ", StateShowDictionaryTool)

        let objCls = cssLessonLessonText.divModifyCharacterPopupAreaHide
        if (StateShowDictionaryTool)
        {
            objCls = cssLessonLessonText.divModifyCharacterPopupArea
        }
        return objCls
    }

    function GetStyleDictionaryToolArea()
    {
        // console.log(COMP_NAME + ".GetStyleDictionaryToolArea: ", mintDictionaryToolTop, mintDictionaryToolLeft)
        let objStyle = {}
        objStyle = {
            top: mintDictionaryToolTop.toString() + "px",
            left: mintDictionaryToolLeft.toString() + "px"
        }
        // console.log("objStyle:", objStyle)
        return objStyle
    }
    // #endregion Get ClassName and Style

    // #region Web Service After Process
    // #endregion Web Service After Process

    // #region Web Service
    // #endregion Web Service

    // #region Component
    // #endregion Component

    // #region Render

    function RenderGoogleClassrommButton()
    {
        let objBlockGoogleClassroomButton = null
        if (!window.gConfig.ForChina)
        {
            // 非China
            if (!window.gSession.App.InApp)
            {
                let strUrl = window.Globals.GenerateShare2GoogleClassroomUrl(mstrLUCatSeqNo)
                console.log("strUrl: ", encodeURIComponent(strUrl))            
                objBlockGoogleClassroomButton = <GoogleShareToClassRoom
                    itemType="assignment"
                    url={strUrl}
                    size={32}
                    theme="classic"
                />
            }
            else
            {
                // In App
                console.log("window.gSession.App.AppVersion:", window.gSession.App.AppVersion)
                var intCheckResult = GlobalLibs.CheckWithCurrentVersion(window.gSession.App.AppVersion, "2.0.8.2");
                if(intCheckResult === -1)
                {
                    // DCP iOS App版號 2.0.8.1以前(含) e.g. iOS 2.0.8.1, 2.0.8.0, 2.0.7 ...
                    objBlockGoogleClassroomButton = null
                }
                else
                {
                    // DCP iOS App版號 2.0.8.2以後(含)
                    objBlockGoogleClassroomButton = <div className={cssLessonLessonText.btnShare2GoogleClassroom4App} onClick={() => Share2GoogleClassroom4AppOnTapHandler()} />
                }
            }
        }
        
        return objBlockGoogleClassroomButton
    }

    function RenderHeaderLeftArea()
    {
        // console.log(COMP_NAME + ".RenderHeaderLeftArea");

        let strTitleEN = props.SubSectionDef.Name;
        let strTitleCN = '';
        if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
        {
            strTitleCN = props.SubSectionDef.MajorName;
        }
        else
        {
            strTitleCN = props.SubSectionDef.MinorName;
        }

        let strInstruction = ""
        if (
            (typeof (props.LUInfo.Instruction) !== 'undefined') &&
            (props.LUInfo.Instruction !== null) &&
            (props.LUInfo.Instruction !== "")
            )
        {
            strInstruction = props.LUInfo.Instruction;
        }

        return (
            <>
                <div className={cssLessonLessonText.divTitleLeftArea}>
                    {RenderGoogleClassrommButton()}
                    <div className={cssLessonLessonText.divTitleSubArea}>
                        <div className={cssLessonLessonText.divLessonIcon}></div>
                        <div className={cssLessonLessonText.divLUTitleTextEN}>
                            {strTitleEN}
                        </div>
                        <div className={cssLessonLessonText.divDividerBar}></div>
                        <div className={cssLessonLessonText.divLUTitleTextCN}>
                            {strTitleCN}
                        </div>
                    </div>
                </div>
                <div className={cssLessonLessonText.divTitleLeftInstructionArea}>{strInstruction}</div>
            </>
        )
    }

    function RenderHeaderRightArea()
    {
        // console.log(COMP_NAME + ".RenderHeaderRightArea")
        return (
            <div className={cssLessonLessonText.divTitleAreaRight}>
                <div className={cssLessonLessonText.divHeaderRightPinyinText}>{window.gAppUI.LBL_ShowPinyin}</div>
                <div className={GetClsPinyinOff()} onClick={() => DisplayPinyinTextOnTapHandler(false)}>{window.gAppUI.BTN_OFF}</div>
                <div className={GetClsPinyinOn()} onClick={() => DisplayPinyinTextOnTapHandler(true)}>{window.gAppUI.BTN_ON}</div>

                <div className={cssLessonLessonText.divTitleRightBar}></div>

                <div className={cssLessonLessonText.divHeaderRightEnglishText}>{window.gAppUI.LBL_ShowEnglish}</div>
                <div className={GetClsEnglishOff()} onClick={() => DisplayEnglishTextOnTapHandler(false)}>{window.gAppUI.BTN_OFF}</div>
                <div className={GetClsEnglishOn()} onClick={() => DisplayEnglishTextOnTapHandler(true)}>{window.gAppUI.BTN_ON}</div>

                <div className={cssLessonLessonText.divTitleRightBar}></div>

                <div className={cssLessonLessonText.divHeaderRightPlayAllText}>{window.gAppUI.LBL_PlayAll}</div>
                <div className={GetClsPlayAllOrPauseAllButton()} onClick={() => PlayAllOrPauseAllAudioOnTapHandler()}></div>
                <div className={GetClsStopAllButton()} onClick={() => StopAllAudioOnTapHandler()}></div>
            </div>
        )
    }

    function RenderDitionaryTool()
    {
        // console.log(COMP_NAME + ".RenderDitionaryTool")
        return (
            <div className={GetClsDictionaryTool(showDitionaryTool)} style={GetStyleDictionaryToolArea()}>
                <div className={cssLessonLessonText.divDiamondArea}></div>
                <div className={cssLessonLessonText.divDitionaryText} 
                    onTouchStart={(event) => DitionaryPointDownHandler(event)} // App
                    onMouseDown={(event) => DitionaryPointDownHandler(event)} // Web
                    >{window.gAppUI.BTN_Glossary}</div>
            </div>
        )
    }

    function RenderContentArea()
    {
        // console.log(COMP_NAME + ".RenderContentArea")
        return (
            <>
                <div ref={mrefScrollArea} className={cssLessonLessonText.divScrollArea}>
                    {props.LUInfo.Sentence.map((Result, SentenceIndex) =>
                        <div key={SentenceIndex} className={cssLessonLessonText.divCellArea} name={"nameScrollSentence"}>
                            <div className={cssLessonLessonText.dviCellDialogArea}>
                                <div className={cssLessonLessonText.divCellDialogNameArea}>
                                    <div className={cssLessonLessonText.divCellDialogNameText}>
                                        {(window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? Result.Character.MajorName : Result.Character.MinorName}
                                    </div>
                                </div>
                                <div className={cssLessonLessonText.divCellDialogSentenceArea}>
                                    <span 
                                    onTouchStart={(e) => TextAreaPointDownHandler(e, SentenceIndex)} // App
                                    onMouseDown={(e) => TextAreaPointDownHandler(e, SentenceIndex)} // Web
                                    className={cssLessonLessonText.divCellDialogSentenceMajorOrMinorText}>{(window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? Result.MajorText.trim() : Result.MinorText.trim()}</span>
                                    <div className={GetClsCellDialogSentencePinyinText()}>{Result.Pinyin}</div>
                                    <div className={GetClsCellDialogSentenceEnglishText()}>{Result.Text}</div>
                                </div>
                            </div>
                            <div className={cssLessonLessonText.divCellItemPlayStopArea}>
                                <div className={GetClsPlayOrPausButton(SentenceIndex)} onClick={() => PlayOneOrPauseOneAudioOnTapHandler(SentenceIndex)}></div>
                                <div className={GetClsStopButton(SentenceIndex)} onClick={() => StopOneAudioOnTapHandler(SentenceIndex)}></div>
                            </div>
                        </div>
                    )}
                    {RenderDitionaryTool()}
                </div>

            </>
        )
    }

    function RenderMainArea()
    {
        // console.log(COMP_NAME + ".RenderMainArea")
        return (
            <>
                {RenderHeaderLeftArea()}
                {RenderHeaderRightArea()}
                <div className={cssLessonLessonText.divContentArea}>
                    {RenderContentArea()}
                </div>
            </>
        )
    }

    return (
        <>
            {RenderMainArea()}
        </>
    )
    // #endregion Render
}
export default LessonLessonText